import React, {FC} from 'react'

const DemosToggleDrawer: FC = () => (
 <></>
)

export {DemosToggleDrawer}
